export default __webpack_public_path__ + "static/media/sc45.398fff0b.mp4";